import { useParams } from '@tanstack/react-router'
import { useTranslation } from '@kostbar/i18n'
import { RestaurantEslForm } from '../components/restaurant-esl-form'
import {
  useRestaurantEslConfig,
  useSaveRestaurantEslConfig,
  useSyncEslNow,
  useTestEslConnection,
} from '../hooks/use-restaurant-esl-config'
import { PermissionGate } from '@/shared/components/permission-gate'
import { ACTIONS } from '@/shared/constants/actions'

export function RestaurantEslPage() {
  const { t } = useTranslation('restaurants')
  const { id } = useParams({ strict: false })
  const restaurantId = Number(id)

  const { data, isLoading } = useRestaurantEslConfig(restaurantId)
  const save = useSaveRestaurantEslConfig(restaurantId)
  const test = useTestEslConnection(restaurantId)
  const sync = useSyncEslNow(restaurantId)

  return (
    <PermissionGate action={ACTIONS.RESTAURANT_ESL_MANAGE}>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold">{t('esl.title')}</h1>
          <p className="text-muted-foreground mt-1">{t('esl.subtitle')}</p>
        </div>

        {!isLoading && (
          <RestaurantEslForm
            config={data}
            onSave={(body) => save.mutate(body)}
            onTest={(apiKey) => test.mutate(apiKey)}
            onSyncNow={() => sync.mutate()}
            saving={save.isPending}
            testing={test.isPending}
            testResult={test.data ?? null}
            syncing={sync.isPending}
          />
        )}
      </div>
    </PermissionGate>
  )
}
